import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { patchFournisseurCodeSiegeEtiquette } from 'utils/posters';


const FournisseurCodeSiegeEtiquette = ({ fournisseurId, valeur, patchFournisseurCodeSiegeEtiquette }) => {

    const [valeurInitiale, setValeurInitiale] = useState(valeur);
    const [valeurCourante, setValeurCourante] = useState(valeur);
    const [error, setError] = useState('');
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);

    // Handler d'annulation de l'édition
    const handleCancel = () => {
        setValeurCourante(valeurInitiale);
        setEditing(false);
        setError('');
    };

    // Handler de modification
    const handleChange = (newValue) => {

        if (isNaN(newValue)) {
            setError("Le code siège doit être seulement composer de chiffres");
        }
        else {
            setValeurCourante(newValue);
            setError('');
        }
    };

    // Handler de sauvegarde
    const handleSave = async () => {

        setEditing(false);

        if (valeurInitiale !== valeurCourante) {

            setSaving(true);

            var result = await patchFournisseurCodeSiegeEtiquette({ id: fournisseurId, codeSiege: valeurCourante });

            if (result) {
                setValeurInitiale(valeurCourante);
            }
            else {
                setValeurCourante(valeurInitiale);
            }
            setSaving(false);
        }
        else {
            console.log("Pas de changement, pas d'appel api");
        }
    };


    return (
        <>
            <TextField
                autoFocus
                disabled={!editing}
                value={valeurCourante}
                onChange={e => handleChange(e.target.value)}
                placeholder='Code siège'
                error={!!error}
                helperText={error}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {!editing && !saving && (
                                <IconButton onClick={() => setEditing(true)}>
                                    <EditIcon />
                                </IconButton>
                            )}

                            {editing && (
                                <>
                                    <IconButton onClick={handleCancel} color="error">
                                        <CancelIcon />
                                    </IconButton>

                                    <IconButton onClick={handleSave} color="success" disabled={!!error}>
                                        <CheckCircleIcon />
                                    </IconButton>
                                </>
                            )}

                            {saving && (
                                <CircularProgress color="secondary" size={16} />
                            )}
                        </InputAdornment>)
                }}
            />
        </>
    );
};

const mapDispatchToProps = {
    patchFournisseurCodeSiegeEtiquette
};

export default connect(null, mapDispatchToProps)(FournisseurCodeSiegeEtiquette);